<mwp-translation />
@switch (mode) {
  @case (registrationMode.RegistrationForm) {
    <form [formGroup]="registrationForm" autocomplete="off">
      <div class="row px-3">
        <div class="mb-3 col-12 px-0">
          <mwp-input [form]="registrationForm" labelName="Email" nameForControl="email" />
        </div>
        <div class="mb-3 col-12 px-0">
          <mwp-input [form]="registrationForm" labelName="Confirm Email" nameForControl="confirmedEmail" />
        </div>
        @if (isFirstResponder) {
          <div class="mb-3 col-12 px-0">
            <mwp-input [form]="firstResponderFormGroup" labelName="Last Name" nameForControl="lastName" />
          </div>
        }
        <div class="mb-3 col-7 pe-1 ps-0">
          <mwp-datepicker [form]="registrationForm" labelName="Date of Birth" nameForControl="dateOfBirth" />
        </div>
        @if (!isFirstResponder) {
          <div class="mb-3 col-5 ps-1 pe-0">
            <mwp-input [form]="registrationForm" labelName="Last 4 SSN" nameForControl="last4SSN" [maxLength]=4 [maskType]="maskType.numericValues" />
          </div>
        }
        <div [ngClass]="isFirstResponder ? 'col-5 ps-1 pe-0' : 'col-12 px-0' " class="mb-1">
          <mwp-input [form]="registrationForm" labelName="Zip Code" nameForControl="zipCode" [maskType]="maskType.zipCode" />
        </div>
      </div>
      <div>
        @if (useSecondaryCaptcha) {
          <mwp-captcha-google [form]="registrationForm" [nameForRadioControl]="reCaptchaToken" [nameForRadioControlId]="reCaptchaTokenId" (emitReloadCaptcha)="reloadCaptcha($event)" />
        } @else {
          <mwp-captcha-cloudflare [form]="registrationForm" [nameForRadioControl]="reCaptchaToken" [nameForRadioControlId]="reCaptchaTokenId" (emitReloadCaptcha)="reloadCaptcha($event)" />
        }
      </div>
    </form>
    <div class="w-100">
      <div class="w-100 mb-3">
        <button class="mwp-button w-100" [disabled]="!registrationForm.valid" (click)="submitRegistration()">
          <mwp-text-translate text="Submit" jsonKey="submit" />
        </button>
      </div>
      @if (!isFirstResponder) {
        <div>
          <button class="mwp-button-secondary w-100 d-flex justify-content-center" (click)="redirectToMemberPage()">
            @if (IsResetPassword) {
              <mwp-text-translate text="Cancel" jsonKey="cancel" />
            } @else {
              <mwp-text-translate text="Returning User - Login Here" jsonKey="returningUserLoginHere" />
            }
          </button>
        </div>
      }
    </div>
  }

  @case (registrationMode.EmailValidation) {
    <div class="message-instructions mb-3">
      <mwp-text-translate [text]="registrationEmailVerifyMessage" jsonKey="registrationEmailVerifyMessage" />
    </div>
    <div>
      <form [formGroup]="verifyEmailCodeForm" autocomplete="off">
        <div class="d-flex justify-content-center mb-4">
          <mwp-verify-code [form]="verifyEmailCodeForm" nameForRadioControl="codeInput" [useFixedWidth]="true" />
        </div>
      </form>
      <button class="mwp-button w-100" [disabled]="verifyEmailCodeForm.invalid" (click)="submitEmailCode()">
        <mwp-text-translate text="Submit" jsonKey="submit" />
      </button>
      <button class="mwp-button-secondary w-100 mt-3" (click)="resendCode()" [disabled]="!buttonEnabled">
        {{getResendButtonText()}}
      </button>
    </div>
  }

  @case (registrationMode.MFAConfigForm) {
    <div class="message-instructions mb-3">
      <div>
        <mwp-text-translate text="Multi-factor authentication" jsonKey="registrationMFAConfigTitle" />
      </div>
      <div>
        <mwp-text-translate text="Please provide your cell phone number and your preferred method to receive a validation code." jsonKey="registrationMFAMessage" />
      </div>
    </div>
    <div>
      <form [formGroup]="mfaForm" autocomplete="off">
        <div class="mb-4 w-100">
          <mwp-input [form]="mfaForm" labelName="Phone Number" nameForControl="phoneNumber" [maskType]="maskType.phone" />
          <div class="mt-2 w-10">
            <mwp-radio-button [form]="mfaForm" [displayInline]="false" nameForControl="verificationType" [data]="authenticatorTypes" keyText="text" keyValue="value" [autoTranslate]="false" />
          </div>
        </div>
      </form>
      <button class="mwp-button w-100" [disabled]="mfaForm.invalid" (click)="submitMFAInfo()">
        <mwp-text-translate text="Submit" jsonKey="submit" />
      </button>
    </div>
  }

  @case (registrationMode.MFAValidation) {
    <div class="message-instructions mb-3">
      <mwp-text-translate [text]="registrationMFAVerifyMessage" jsonKey="registrationMFAVerifyMessage" />
    </div>
    <div>
      <form [formGroup]="verifyMFAForm" autocomplete="off">
        <div class="d-flex justify-content-center mb-4">
          <mwp-verify-code [form]="verifyMFAForm" nameForRadioControl="codeInput" [useFixedWidth]="true" />
        </div>
      </form>
      <button class="mwp-button w-100" [disabled]="verifyMFAForm.invalid" (click)="submitMFACode()">
        <mwp-text-translate text="Submit" jsonKey="submit" />
      </button>
      <button class="mwp-button-secondary w-100 mt-3" (click)="resendCode()" [disabled]="!buttonEnabled">
        {{getResendButtonText()}}
      </button>
      <button class="mwp-button-secondary w-100 mt-3" (click)="changeMFA()">
        <mwp-text-translate text="Change MFA Credentials" jsonKey="changeMFA" />
      </button>
    </div>
  }

  @case (registrationMode.CreatePassword) {
    <div class="message-instructions mb-3">
      <mwp-text-translate text="Create Password" jsonKey="createPassword" />
    </div>
    <div>
      <mwp-password [displayHeader]="false" (emitPassword)="submitPassword($event)" />
    </div>
  }

  @case (registrationMode.MemberSelect) {
    <div>
      <mwp-multi-member-select [baseMemberSessionList]="baseMemberSessionList" [isRegister]="true" (submit)="submitSelectMember($event)" />
    </div>
  }
}